import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithPassword,sendOtp, verifyOtp } from '../../../queries/userlogin';

export default function AuthComponent() {
  const [step, setStep] = useState('choice'); // 'choice' | 'password' | 'otp'
  const [number, setNumber] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [deviceId] = useState('device-xyz'); // Replace or generate securely
  const navigate = useNavigate();

  const containerStyle = {
    maxWidth: '420px',
    margin: '50px auto',
    padding: '40px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '20px',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Arial, sans-serif',
    color: '#fff',
  };

  const innerContainerStyle = {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '15px',
    padding: '30px',
    color: '#333',
  };

  const logoContainerStyle = {
    textAlign: 'center',
    marginBottom: '20px',
  };

  const logoStyle = {
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    objectFit: 'cover',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
    marginBottom: '15px',
  };

  const titleStyle = {
    textAlign: 'center',
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '25px',
    color: '#2c3e50',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  };

  const inputStyle = {
    width: '100%',
    padding: '15px',
    margin: '10px 0',
    borderRadius: '12px',
    border: '2px solid #e1e8ed',
    fontSize: '16px',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: '#f8f9fa',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '15px',
    margin: '12px 0',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
    boxShadow: '0 4px 15px rgba(66, 133, 244, 0.4)',
  };

  const handlePasswordLogin = async () => {
    try {
      const { data } = await loginWithPassword({ number, password });
      if (data.success) {
        localStorage.setItem('_USER_TOKEN_', data.token);
        window.location.href = '/user/profile';
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('Login failed');
    }
  };

  const handleSendOtp = async () => {
    try {
      const { data } = await sendOtp({ number });
      if (data.success) {
        setStep('otp');
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('Failed to send OTP');
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const { data } = await verifyOtp({ number, otp });
      if (data.success) {
        localStorage.setItem('_USER_TOKEN_', data.token);
        window.location.href = '/user/profile';
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert('OTP verification failed');
    }
  };

  return (
    <div style={containerStyle}>
      <div style={innerContainerStyle}>
        <div style={logoContainerStyle}>
          <img 
            src="/assets/img/app_logo.png" 
            alt="MastiShorts Logo" 
            style={logoStyle}
          />
        </div>
        <h2 style={titleStyle}>User Login</h2>

      {step === 'choice' && (
        <>
          <input
            type="text"
            placeholder="Phone number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            style={inputStyle}
          />
          <button onClick={() => setStep('password')} style={buttonStyle}>
            Login with Password
          </button>
          <button onClick={handleSendOtp} style={secondaryButtonStyle}>
            Send OTP
          </button>
        </>
      )}

      {step === 'password' && (
        <>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
          <button onClick={handlePasswordLogin} style={buttonStyle}>
            Submit
          </button>
        </>
      )}

      {step === 'otp' && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={inputStyle}
          />
          <button onClick={handleVerifyOtp} style={buttonStyle}>
            Verify OTP
          </button>
        </>
      )}
      </div>
    </div>
  );
}
